import React from "react";

const DollarIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#667085"
      className="size-6"
      {...props}
    >
      <g transform="translate(12 12) scale(1.5) translate(-12 -12)">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 7v10m-2-2.5.7.5c.9.7 2.3.7 3.2 0 .9-.7.9-1.8 0-2.5-.6-.5-1.2-.7-1.9-.7-.7 0-1.3-.2-1.8-.6-.8-.7-.8-1.8 0-2.5s2.1-.7 2.9 0l.3.2"
        />
      </g>
    </svg>
  );
};

export default DollarIcon;
